export const HOME_BASE_TYPE_LABELS = {
  'marina-slip': 'Marina Slip',
  'commercial-dock': 'Commercial Dock',
  'private-hoa-dock': 'Private or HOA Dock',
  'public-dock-ramp': 'Public Dock or Ramp',
  'mooring-buoy': 'Mooring Buoy',
  'on-trailer': 'Trailer',
  'storefront': 'Storefront',
};

export const PICKUP_OPTION_LABELS = {
  'board-at-home-base': 'Board at Home Base',
  'customer-pickup': 'Customer Pick-Up',
  'provider-delivers': 'Provider Delivery',
  'customer-tow-away': 'Customer Tow-Away',
  'third-party-ok': '3rd Party Delivery',
};

export const APPROVED_DESTINATION_LABELS = {
  'public-dock-ramp': 'Public Dock or Ramp',
  'private-hoa-dock': 'Private or HOA Dock',
  'mooring-buoy': 'Private Mooring Buoy',
  'trailer-delivery': "Customer's Address (trailer delivery)",
  'customer-address-land': "Customer's Address (land delivery)",
  'other': 'Other (see delivery notes)',
};
